import {useQuery} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {KycRecord} from "../domain/kyc.entity";
import {createKycRepository} from "../data/repositories";

// ==================== Query Keys ====================

export const KYC_QUERY_KEYS = {
  all: ["kyc"] as const,
  status: () => [...KYC_QUERY_KEYS.all, "status"] as const,
};

/** Legacy query key for backward-compatible cache invalidation. */
export const LEGACY_KYC_QUERY_KEY = ["kyc-status"] as const;

// ==================== Hook ====================

/**
 * Hook for fetching the authenticated user's KYC status.
 * Returns KycRecord entity or null (no record exists).
 */
export const useKycStatus = (enabled = true) => {
  const repository = createKycRepository();

  return useQuery<KycRecord | null, AxiosError<{message: string}>>({
    queryKey: KYC_QUERY_KEYS.status(),
    queryFn: () => repository.getKycStatus(),
    enabled,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
